import { EvaluationField } from "@/components/EvaluationField";
import { PlaygroundSectionLayout } from "../PlaygroundSectionLayout";
import { PlaygroundSubSectionLayout } from "../PlaygroundSubSectionLayout";
import { PlaygroundSubSectionTitle } from "../PlaygroundSubSectionTitle";

const binaryRatingScale: Record<string, number> = {
  YES: 1,
  NO: 0,
  NOT_APPLICABLE: 0,
};

export function PlaygroundReviewEvaluationField() {
  return (
    <PlaygroundSectionLayout>
      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>
          Binary question — NA switch alignment, AI-evaluated marker, Yes/No
          answer icons
        </PlaygroundSubSectionTitle>
        <div className="w-[576px]">
          <EvaluationField<string>
            mode="binary"
            rank={1}
            question="Did the agent greet the customer and introduce the company?"
            ratingScale={binaryRatingScale}
            maximumPoints={1}
            rating="YES"
            possiblyNotApplicable
            hasAiAnswer
            comment="The agent greeted the customer warmly and stated the company name."
          />
        </div>
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>"No" answer icon</PlaygroundSubSectionTitle>
        <div className="w-[576px]">
          <EvaluationField<string>
            mode="binary"
            rank={2}
            question="Did the agent confirm the customer's contact details?"
            ratingScale={binaryRatingScale}
            maximumPoints={1}
            rating="NO"
            possiblyNotApplicable
          />
        </div>
      </PlaygroundSubSectionLayout>
    </PlaygroundSectionLayout>
  );
}
